export default "__VITE_ASSET__1a914efd__"